import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckCircleOutlined, MinusCircleOutlined } from "@ant-design/icons";
import { Space, Spin, Tag } from "antd";
import { observer } from "mobx-react";
import { useState } from "react";
import { DashboardChecklistItem } from "./checklistItem.js";
import { useStores } from "../../../store/stores.js";
import { __ } from "../../../utils/i18n.js";
const DashboardChecklistCardContent = observer(({ onLinkClick, ...props })=>{
    const { checklistStore } = useStores();
    const { busyChecklist, items, completed, checkable, done, checklist: { overdue } } = checklistStore;
    const [showHidden, setShowHidden] = useState(typeof props.showHidden === "boolean" ? props.showHidden : done ? false : true);
    return /*#__PURE__*/ _jsx(Spin, {
        spinning: busyChecklist,
        children: /*#__PURE__*/ _jsxs(Space, {
            direction: "vertical",
            size: "large",
            children: [
                overdue && /*#__PURE__*/ _jsx("div", {
                    className: "notice notice-warning inline below-h2 notice-alt",
                    style: {
                        margin: 0
                    },
                    children: /*#__PURE__*/ _jsx("p", {
                        children: __("How time flies! You have installed Real Cookie Banner some time ago, but you still haven't finished the configuration yet.")
                    })
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "description",
                    children: __("We have collected all relevant steps for the legally compliant use of Real Cookie Banner after the first installation. Set up the cookie banner step by step to add a cookie banner to your website in compliance with the ePrivacy Directive and GDPR.")
                }),
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        done && (showHidden ? /*#__PURE__*/ _jsx(Tag, {
                            icon: /*#__PURE__*/ _jsx(MinusCircleOutlined, {}),
                            color: "default",
                            style: {
                                cursor: "pointer"
                            },
                            onClick: ()=>setShowHidden(false),
                            children: __("Hide completed steps")
                        }) : /*#__PURE__*/ _jsx(Tag, {
                            icon: /*#__PURE__*/ _jsx(CheckCircleOutlined, {}),
                            color: "success",
                            style: {
                                cursor: "pointer"
                            },
                            onClick: ()=>setShowHidden(true),
                            children: __("%d / %d steps completed", completed.length > checkable.length ? checkable.length : completed.length, checkable.length)
                        })),
                        items.map(({ id, ...rest })=>{
                            if (!showHidden && rest.checked) {
                                return null;
                            }
                            return /*#__PURE__*/ _jsx(DashboardChecklistItem, {
                                id: id,
                                ...rest,
                                onLinkClick: (e)=>{
                                    if ([
                                        "get-pro"
                                    ].indexOf(id) > -1) {
                                        checklistStore.toggleChecklistItem(id, true);
                                    }
                                    onLinkClick?.(e);
                                }
                            }, id);
                        })
                    ]
                })
            ]
        })
    });
});
export { DashboardChecklistCardContent };
